import { APIClientError } from './api-client-error';

export class ValidationError extends APIClientError {
  public readonly validationErrors: unknown;

  public constructor(message: string, validationErrors: unknown, path?: string) {
    super(message, undefined, undefined, path);
    this.name = 'ValidationError';
    this.validationErrors = validationErrors;
  }
}
